import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaInstagram, FaWhatsapp } from 'react-icons/fa';

import { usePublicExperience } from '../context/PublicExperienceContext';
import { isInternalLink } from '../utils/publicLinks';

const isInstagramLink = (link) =>
  String(link?.id || '').toLowerCase().includes('instagram') ||
  String(link?.label || '').toLowerCase().includes('instagram');

const isWhatsAppLink = (link) =>
  String(link?.id || '').toLowerCase().includes('whatsapp') ||
  String(link?.label || '').toLowerCase().includes('whatsapp');

function Footer() {
  const location = useLocation();
  const isHomeRoute = location.pathname === '/';
  const { experience } = usePublicExperience();
  const branding = experience?.data?.branding || {};
  const footerLinks = Array.isArray(experience?.data?.navigation?.footer)
    ? experience.data.navigation.footer
        .filter((link) => link?.visible !== false)
        .sort((left, right) => Number(left?.sortOrder || 0) - Number(right?.sortOrder || 0))
    : [];
  const creditLink = (
    <a
      href="https://www.comercias.com.br/"
      target="_blank"
      rel="noopener noreferrer"
      className="footer-credit-link"
      aria-label="Visitar site da Comerc IA's"
    >
      Comerc IA&apos;s
    </a>
  );

  return (
    <footer className="footer-confeitaria mt-auto">
      <div className="container py-4">
        <div className="d-flex flex-column align-items-center text-center gap-3">
          <div className="d-flex align-items-center justify-content-center gap-3">
            {footerLinks.map((link) => (
              isInternalLink(link) ? (
                <Link key={link.id || link.href} to={link.href} className="social-icon" aria-label={link.label}>
                  <span>{link.label}</span>
                </Link>
              ) : (
                <a
                  key={link.id || link.href}
                  href={link.href}
                  target={link.kind === 'external' ? '_blank' : undefined}
                  rel={link.kind === 'external' ? 'noopener noreferrer' : undefined}
                  className="social-icon"
                  aria-label={link.label}
                >
                  {isInstagramLink(link) ? (
                    <FaInstagram />
                  ) : isWhatsAppLink(link) ? (
                    <FaWhatsapp />
                  ) : (
                    <span>{link.label}</span>
                  )}
                </a>
              )
            ))}
          </div>

          <small className="footer-text footer-copyright">
            &copy; {new Date().getFullYear()} {branding?.displayName || 'Glace Confeitaria'}. Todos
            os direitos reservados.
            {isHomeRoute ? (
              <>
                {' | '}
                P&aacute;gina criada por {creditLink}
              </>
            ) : (
              <>
                <br />
                P&aacute;gina criada por {creditLink}
              </>
            )}
          </small>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
